import { render, staticRenderFns } from "./detail-take.vue?vue&type=template&id=42f9e2eb&scoped=true&"
import script from "./detail-take.vue?vue&type=script&lang=js&"
export * from "./detail-take.vue?vue&type=script&lang=js&"
import style0 from "./detail-take.vue?vue&type=style&index=0&id=42f9e2eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f9e2eb",
  null
  
)

export default component.exports